import { ChainId } from '@pancakeswap/sdk'
import addresses from 'config/constants/contracts'
import { Address } from 'config/constants/types'

export const getAddress = (address: Address): string => {
  const chainId = process.env.REACT_APP_CHAIN_ID
  return address[chainId] ? address[chainId] : address[ChainId.MAINNET]
}

export const getMasterChefAddress = () => {
  return getAddress(addresses.masterChef)
}
export const getLaunchpadv1Address = () => {
  return getAddress(addresses.Launchpadv1)
}
export const getIfoV4Address = () => {
  return getAddress(addresses.IfoV4)
}
export const getMulticallAddress = () => {
  return getAddress(addresses.multiCall)
}
export const getLotteryV2Address = () => {
  return getAddress(addresses.lotteryV2)
}
export const getPancakeProfileAddress = () => {
  return getAddress(addresses.pancakeProfile)
}
export const getPancakeRabbitsAddress = () => {
  return getAddress(addresses.pancakeRabbits)
}
export const getBunnyFactoryAddress = () => {
  return getAddress(addresses.bunnyFactory)
}
export const getClaimRefundAddress = () => {
  return getAddress(addresses.claimRefund)
}
export const getPointCenterIfoAddress = () => {
  return getAddress(addresses.pointCenterIfo)
}
export const getBunnySpecialAddress = () => {
  return getAddress(addresses.bunnySpecial)
}
export const getTradingCompetitionAddress = () => {
  return getAddress(addresses.tradingCompetition)
}
export const getEasterNftAddress = () => {
  return getAddress(addresses.easterNft)
}
export const getCakeVaultAddress = () => {
  return getAddress(addresses.cakeVault)
}
export const getPredictionsAddress = () => {
  return getAddress(addresses.predictions)
}
export const getChainlinkOracleAddress = () => {
  return getAddress(addresses.chainlinkOracle)
}
export const getBunnySpecialCakeVaultAddress = () => {
  return getAddress(addresses.bunnySpecialCakeVault)
}
export const getBunnySpecialPredictionAddress = () => {
  return getAddress(addresses.bunnySpecialPrediction)
}
export const getBunnySpecialLotteryAddress = () => {
  return getAddress(addresses.bunnySpecialLottery)
}
export const getFarmAuctionAddress = () => {
  return getAddress(addresses.farmAuction)
}
export const getAnniversaryAchievement = () => {
  return getAddress(addresses.AnniversaryAchievement)
}
export const getNftMarketAddress = () => {
  return getAddress(addresses.nftMarket)
}
export const getNftSaleAddress = () => {
  return getAddress(addresses.nftSale)
}
export const getPancakeSquadAddress = () => {
  return getAddress(addresses.pancakeSquad)
}
export const getNFTAddress = () => {
  return getAddress(addresses.nft)
}
export const getStakingAddress = () => {
  return getAddress(addresses.staking)
}
export const getRewardAddress = () => {
  return getAddress(addresses.reward)
}
export const getMulticallAddress1 = () => {
  return getAddress(addresses.multicall1)
}
export const getMulticallAddress2 = () => {
  return getAddress(addresses.multicall2)
}
export const getMulticallAddress3 = () => {
  return getAddress(addresses.multicall3)
}
export const getRegisterAddress = () => {
  return getAddress(addresses.register)
}
export const getRouterAddress = () => {
  return getAddress(addresses.pancakeRouter)
}
export const getWBNBAddress = () => {
  return getAddress(addresses.WBMB)
}
export const getOriginAddress = () => {
  return getAddress(addresses.nft)
}
export const getMarketplaceAddress = () => {
  return getAddress(addresses.marketplace)
}
export const getUSDTAddress = () => {
  return getAddress(addresses.USDT)
}
export const getPriceFeedAddress = () => {
  return getAddress(addresses.PRICE_FEED)
}